export enum RaffleWinningCriteriaEnum {
  DATES = 'dates',
  ALL = 'all'
}
